(function ($) {
    'use strict';
	

    function animateSliderCaption() {
        $('.tm-animated-text').textillate({
            loop: false,
            autoStart: true,
            minDisplayTime: 4000,
            in: {
                delayScale: 1.1,
                delay: 30,
                sync: false,
                reverse: false,
            },
            out: {
                delayScale: 1.1,
                delay: 30,
                sync: false,
                reverse: false,
            },
        });
    }


    function updateSliderCaption(nextSlide) {
        if (typeof herosliderCaptions == 'undefined') return;
        if (!herosliderCaptions.length) return;

        let caption = herosliderCaptions[nextSlide]; // See index.php

        let html = '<h1 class="wow tm-animated-text" data-in-effect="rollIn" data-out-effect="fadeOutDown" data-out-shuffle="true" data-wow-delay="0.5s">';
        html += caption.heading;
        html += '</h1>';
        html += '<p class="wow" data-wow-delay="0.7s">';
        html += caption.text;
        html += '</p>';
        html += '<a href="' + caption.button_url + '" class="tm-button wow" data-wow-delay="0.9s">';
        html += caption.button_text;
        html += '</a>';
        
        $('.heroslider-caption').html(html);
        animateSliderCaption();
    }

   

    

    /* Preloader */
    

    var sasna = {

        /* Inline Background Image */
        dataBgImage: function () {
            $('[data-bgimage]').each(function () {
                var imageUrl = $(this).data('bgimage');
                $(this).css({
                    'background-image': 'url(' + imageUrl + ')'
                });
            });
        },

        /* Heroslider Height */
        herosliderHeight: function () {
            var headerHeight = $('.navbar-area').innerHeight();

            $('.heroslider-singleslider').css({
                'min-height': 'calc(100vh - ' + headerHeight + 'px)',
            });
        },

        /* Slider Activations */
        sliderActivations: {

            /* Heroslider Activation */
            heroSliderActivation: function () {
                updateSliderCaption(0);
                $('.heroslider-slider').slick({
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 5000,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    fade: true,
                    arrows: true,
                    dots: true,
                    prevArrow:"<button type='button' class='slid slick-prev'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
                    nextArrow:"<button type='button' class='slid slick-next'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
                    adaptiveHeight: false,
                    responsive: [{
                        breakpoint: 1201,
                        settings: {
                            adaptiveHeight: true
                        }
                    }]
                }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                    updateSliderCaption(nextSlide);
                });
            },

           
            /* Blog Slider Activation */
            blogSliderActivation: function () {
                $('.blog-slider-active').slick({
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 2000,
                    slidesToShow: 5,
                    slidesToScroll: 3,
                    arrows: false,
                    dots: false,
                    responsive: [{
                        breakpoint: 1800,
                        settings: {
                            slidesToShow: 4,
                        }
                    },
                    {
                        breakpoint: 1300,
                        settings: {
                            slidesToShow: 3,
                            slidesToScroll: 2,
                        }
                    },
                    {
                        breakpoint: 992,
                        settings: {
                            slidesToShow: 2,
                            slidesToScroll: 1,
                        }
                    },
                    {
                        breakpoint: 576,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1
                        }
                    }
                    ]
                });
            },

            /* Slider Activations Initializer ( Just Remove a single line if you want to disable any slider ) */
            init: function () {
                sasna.sliderActivations.heroSliderActivation();
                // sasna.sliderActivations.heroSliderActivation2();
                // sasna.sliderActivations.featureSliderActivation();
                // sasna.sliderActivations.testimonialSliderActivation();
                // sasna.sliderActivations.testimonialSlider2Activation();
                // sasna.sliderActivations.productVerticalSliderActivation();
                sasna.sliderActivations.blogSliderActivation();
                // sasna.sliderActivations.brandlogoSliderActivation();
                // sasna.sliderActivations.portfolioGallerySliderActivation();
                // sasna.sliderActivations.blogGallerySliderActivation();
                // sasna.sliderActivations.productDetailsImageSlider();
                // sasna.sliderActivations.similliarProductSlider();
            }

        },

        /* Animated Headline Active */
        animatedHeadline: function () {
            animateSliderCaption();
        },

        /* Blog Hover State */
        // blogHoverState: function () {
        //     $('.blogitem').each(function () {
        //         $(this).on('mouseover', function () {
        //             $(this).find('.blogitem-content').find('.tm-button').removeClass('tm-button-dark');
        //         }).on('mouseout', function () {
        //             $(this).find('.blogitem-content').find('.tm-button').addClass('tm-button-dark');
        //         });
        //     });
        // },

        /* Blog Social Action */
        // blogSocialAction: function () {
        //     $('.blogitem').each(function () {
        //         $(this).find('.blogitem-share-trigger').on('click', function () {
        //             $(this).toggleClass('is-active');
        //             $(this).siblings('ul').toggleClass('is-visible');
        //         });
        //     });
        // },

        // stickySidebarActive: function () {
        //     var winWidth = $(window).width();
        //     if (winWidth > 991) {
        //         $('.sticky-sidebar').stickySidebar({
        //             topSpacing: 0,
        //             bottomSpacing: 30
        //         });
        //     }
        // },

        /* Blog Masonry Active */
        // blogMasonryActive: function () {
        //     $('.blog-masonry-active').masonry({
        //         itemSelector: '.blog-masonry-item'
        //     });
        // },




        /* Initializer */
        init: function () {
            // sasna.meanmenuActivation();
            sasna.dataBgImage();
            sasna.herosliderHeight();
            sasna.sliderActivations.init();
           
        }
    };

    sasna.init();
  
  if($('.new-row div').length > 3) {
         $('.new-row').slick({
                    infinite: true,
                    autoplay: true,
                    autoplaySpeed: 2000,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: false,
                    dots: false,
                    responsive: [{
                            breakpoint: 1800,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 1300,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 2,
                            }
                        },
                        {
                            breakpoint: 992,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 1,
                            }
                        },
                        {
                            breakpoint: 576,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1
                            }
                        }
                    ]
                });  
    	           
    }
           
  if($('.related li').length > 3) {
            $('.related').slick({
                infinite: true,
                speed: 300,
                autoplay: true,
                margin:10,
                autoplaySpeed: 3500,
                slidesToShow: 3,
                prevArrow:"<button type='button' class='slick-prev pull-left'><i class='fa fa-angle-left' aria-hidden='true'></i></button>",
                nextArrow:"<button type='button' class='slick-next pull-right'><i class='fa fa-angle-right' aria-hidden='true'></i></button>",
                slidesToScroll: 4,
                responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots:false
                    }
                },
                {
                    breakpoint: 600,
                    settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
                ]
            });
        }


})(jQuery);